import type { NavGroup, NavItem } from './nav-groups';

export function isNavItemActive(pathname: string, href: string): boolean {
  return pathname === href || pathname.startsWith(`${href}/`);
}

/**
 * Returns the most specific destination for a path. This avoids a parent
 * route masking a detail page when destinations share a prefix.
 */
export function findActiveNavItem(pathname: string, groups: NavGroup[]): NavItem | null {
  const matches = groups.flatMap((group) =>
    group.items.filter((item) => isNavItemActive(pathname, item.href))
  );

  return matches.reduce<NavItem | null>(
    (mostSpecific, item) =>
      !mostSpecific || item.href.length > mostSpecific.href.length ? item : mostSpecific,
    null
  );
}

export function findActiveNavGroup(pathname: string, groups: NavGroup[]): NavGroup | null {
  const item = findActiveNavItem(pathname, groups);
  return item
    ? groups.find((group) => group.items.some((candidate) => candidate.href === item.href)) ?? null
    : null;
}